module.exports = "https://static.energy5.com/_next/static/images/easeOfUseImage-4a7d955c18d8c7632fddf7c5dfef9b1e.jpg";